import React from 'react';
//IMPORTS MATERIAL UI
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import DialogContentText from '@material-ui/core/DialogContentText';
import { makeStyles } from '@material-ui/core/styles';
//IMPORTS COMPONENTS DATE & SELECT
import DateComponent from './dateComponent'
import SelectComponent from './selectComponent'
//NOTIFICATIONS
import AddAlert from "@material-ui/icons/AddAlert";
import Snackbar from "./Snackbar.js";
//CREATE STYLES
const useStyles = makeStyles(theme => ({
  textField: {
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(0),
  },
}))

export default function FormDialog(props) {
  const [open, setOpen] = React.useState(false)
  const data = props.data
  const labels = labelsForm()
  const fk = props.fk//ARRAY FOREIGN KEYS
  const fkEntity = props.fkEntity//OBJECT FOREIGN KEYS DATA
  var rowData = props.rowData
  const id = props.id
  const classes = useStyles();
  var cont = 0
//NOTIFICATION COMPONENT
const [tc, setTC] = React.useState(false);
  const showNotification = place => {
      switch (place) {
        case "tc":
          if (!tc) {
            setTC(true);
            setTimeout(function() {
              setTC(false);
            }, 2000);
          }
          break;
    }
  }

  function labelsForm(){
    var label = {
      'label':[]
    }    
    data.map((element) =>{ //CHECK DATAFIELDS
      if(fk && (fk.includes(element.name))){ //COMPARE ARRAY FOREIGN KEYS AND DATAFIELDS FR CREATE LABELS FOR SLECT COMPONENT
        label.label.push({
          'name':element.name,
          'type':element.type
        })
      }
      if(element.form == true){ //CREATE LABELS FOR NORMAL INPUT COMPONENT
        label.label.push({
          'name':element.name,
          'type':element.type
        })
      }
    })
    return label.label
}

  function handleClickOpen() {
    setOpen(true);
  }

  function createUpdateForm(name, type, required, form){
    if (form==true && rowData!=null){
    switch(type){
      case 'date':
        return(
          <DateComponent 
          key={name} 
          defaultValue={rowData[name]}
          id={name}
          label={getLabel(name)} 
          name={name}/>//CREATE DATE COMPONENT
        )
      case 'number':
        return (
          <TextField 
            key={name} 
            className={classes.textField} 
            autoFocus 
            margin={'normal'} 
            InputLabelProps={{shrink: true,}} 
            variant={'outlined'} 
            id={name} 
            type={type} 
            name={name} 
            required={required} 
            defaultValue={rowData[name]}
            label={getLabel(name)} 
            fullWidth/>
            )
      case 'text':
        return (
          <TextField 
            key={name} 
            className={classes.textField} 
            autoFocus 
            margin={'normal'} 
            InputLabelProps={{shrink: true,}} 
            variant={'outlined'} 
            id={name} 
            type={type} 
            name={name} 
            required={required} 
            defaultValue={rowData[name]}
            label={getLabel(name)} 
            fullWidth/>
            )
      }
    }
  }

  function getLabel(datafield){
    return datafield.toUpperCase()
  }

  function handleClose() {
    setOpen(false);
  }
  
  function getDate() {
    let date =  new Date()
    let anio = date.getFullYear()
    let mes = date.getMonth()+1
    let dia = date.getDate()
    if(dia<9){
      dia='0'+dia
    }
    date = anio + '-' + mes + '-' + dia
    console.log(date)
    return date
  }
  
  function buildBody(){
    var data = new Object() //OBJECT TO SAVE ALL DATA
    var keyData = new Object() //OBJECT TO SAVE KEY DATA & VALUE
    var i = 0 //COUNTER FOR INPECT EVERY POSITION IN OBJECT
    props.data.map((element)=>{ //CHECK LABELS OBJECT //PARCHE (PROPS.DATA => LABELS)
      if(element.form == true){
      var type = element.type //GET TYPE FOR EVERY COMPONENT
      switch(type){
        case 'number': //GET COMPONENT VALUE IN EVERY ID AND TRANSFORM DATATYPE
          keyData[element.name] = Number(document.getElementById(labels[i].name).value)
          break
        case 'text': //GET COMPONENT VALUE IN EVERY ID AND TRANSFORM DATATYPE
          keyData[element.name] = String(document.getElementById(labels[i].name).value)
          break
        case 'date'://GET COMPONENT VALUE IN EVERY ID AND BUILD FORMAT DATE
          let value = document.getElementById(labels[i].name).value
          const [anio, mes, dia] = value.split('/')
          const date  = [anio, '-', mes, '-', dia].join('');
          //BUILD ALL DATA FOR REQUEST
          keyData[element.name] = String(date)
          break
      }
      i++}
      if(element.name=='active'){
        keyData[element.name]=true
        }else if(element.name=='created_on' || element.name=='updated_on'){
        keyData[element.name]=getDate()
        }else if(element.name=='created_by' || element.name=='updated_by'){
        keyData[element.name]='System'            
        }//END PARCHE
    })
    // keyData[props.id]=state.id
    keyData[props.record+id] = rowData[id]
    //BUILD FINAL BODY
    // data[deleteLastCharacter(props.record)]=keyData
    data[props.record]=keyData
    // setState({ ...state, [props.id]: '' })
    //RETURN BODY
    return data
  }

  function put(e){
    var body = buildBody()
    e.preventDefault()
    console.log(JSON.stringify(body))
    var xhr = new XMLHttpRequest();
    xhr.open('PUT', props.host+props.entity, true);
    //Send the proper header information along with the request
    xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
    xhr.send(JSON.stringify(body));
    xhr.onreadystatechange = function() { // Call a function when the state changes.
      if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
        // showNotification("tc")
        alert('An element has been updated')
          props.onClick(true)
      }else{
        console.log('Error during update')
      }
    }
    handleClose()
  }

  function createComboBox(element){//CREATE COMBO BOX COMPONENT WITH FOREIGN KEYS
    cont++
    return(
      <SelectComponent 
      key={fk[cont-1].name+cont} //KEY FOR NEW COMPONENT
      name={fk[cont-1].name} //NAME
      label={getLabel(fk[cont-1].name)} //LABEL FOR COMPONENT
      items={element[fk[cont-1].name]}/> //ITEMS OPTIONS IN SELECT COMPONENT
    )
  }

  if(rowData==null){
    return (<div>
      <Fab size={'small'} color="secondary" aria-label="edit" onClick={handleClickOpen}>
        <EditIcon />
      </Fab>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Select an item</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please select an item from Grid.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant={'contained'} onClick={handleClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
  }else if(fkEntity!=null){
  return (
    <div enabled={props.hidden}>
      <Fab size={'small'} color="secondary" aria-label="edit" onClick={handleClickOpen}>
        <EditIcon />
      </Fab>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle >MODIFY {getLabel(props.record)}?</DialogTitle>   
        <form className={'commentForm'} onSubmit={put} method={'PUT'}>
        <DialogContent align={'left'}>
          {/**Create comboBox by Foreign keys */}
          {fkEntity.map((element)=>
            createComboBox(element)
          )}
          {/**create inputs */}
          {data.map((element)=>
            createUpdateForm(element.name, element.type, element.required, element.form)           
          )}
        </DialogContent>
        <DialogActions>
          <Button variant={'contained'} onClick={handleClose} color={'secondary'}>
            No
          </Button>
          <Button variant={'contained'} type={'submit'} color={'primary'}>
            Yes
          </Button>
        </DialogActions>        
        </form>
      </Dialog>
      <Snackbar
        place="tc"
        color="success"
        icon={AddAlert}
        message="Welcome to MATERIAL DASHBOARD PRO - a beautiful admin panel for every web developer."
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />
    </div>
  );
  }else{
    return (
      <div enabled={props.hidden}>
        <Fab size={'small'} color="secondary" aria-label="edit" onClick={handleClickOpen}>
          <EditIcon />
        </Fab>
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle >MODIFY {getLabel(props.record)}?</DialogTitle>   
          <form className={'commentForm'} onSubmit={put} method={'PUT'}>
          <DialogContent align={'left'}>
            {data.map((element)=>
              createUpdateForm(element.name, element.type, element.required, element.form)           
            )}
          </DialogContent>
          <DialogActions>
            <Button variant={'contained'} onClick={handleClose} color={'secondary'}>
              No
            </Button>
            <Button variant={'contained'} type={'submit'} color={'primary'}>
              Yes
            </Button>
          </DialogActions>        
          </form>
        </Dialog>
        <Snackbar
          place="tc"
          color="success"
          icon={AddAlert}
          message="Welcome to MATERIAL DASHBOARD PRO - a beautiful admin panel for every web developer."
          open={tc}
          closeNotification={() => setTC(false)}
          close
        />
      </div>
    );
    }
}